export function addScroll() {
    let $parentElement = $(".slider-has-custom-scroll");
    let $scrollContainers = $parentElement.find(".info-holder");

    for (let i = 0; i < $scrollContainers.length; i++) {
        OverlayScrollbars($scrollContainers.eq(i), {});
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/addScroll.js